import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
import axios from 'axios';

const state = {
  contactTopic:[],
  contactAdvertisements: [],
  contactPeriods:[],
  dataContact:[],
  isSuccess: false,
};
const getters = {
  contactTopic: (state) => state.contactTopic,
  contactAdvertisements: (state) => state.contactAdvertisements,
  contactPeriods:(state) => state.contactPeriods,
  dataContact:(state) => state.dataContact,
  isSuccess: (state) => state.isSuccess,
};

const actions = {
  [actionType.GET_DATA_USER_CONTACT_TOPIC]: async function ({ commit }) {
    return new Promise((resolve, reject) => {
      api.get("/user/contact-topics").then(result => {
        commit(mutationType.SET_DATA_USER_CONTACT_TOPIC, {
          data: result.data.data
        })
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_DATA_USER_CONTACT_ADVERTISEMENT]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get("/user/contact-advertisements").then(result => {
        commit(mutationType.SET_DATA_USER_CONTACT_ADVERTISEMENT, {
          data: result.data.data
        })
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_DATA_USER_CONTACT_PERIOD]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get("user/contact-periods").then(result => {
        commit(mutationType.SET_DATA_USER_CONTACT_PERIOD, {
          data: result.data.data
        })
      })
        .catch(error => reject(error));
    });
  },
  [actionType.POST_DATA_CONTACT]: async function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post("user/contacts",data)
      .then(result => {
        resolve(result);
        commit(mutationType.POST_DATA_CONTACT_SUCCESS, {
          data: result.data
        })
      })
        .catch(error => reject(error));
    });
  }
};

const mutations = {
  [mutationType.SET_DATA_USER_CONTACT_TOPIC](state, data) {
    state.contactTopic = data.data
  },
  [mutationType.SET_DATA_USER_CONTACT_ADVERTISEMENT](state, data) {
    state.contactAdvertisements = data.data
  },
  [mutationType.SET_DATA_USER_CONTACT_PERIOD](state, data) {
    state.contactPeriods = data.data
  },
  [mutationType.POST_DATA_CONTACT_SUCCESS](state, data) {
    state.dataContact = data.data.data;
    state.isSuccess = data.data.success;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}